export function splitItemsIntoColumns({ items, minPerColumn = 13, maxColumns = 5 }) {
  if (!items.length) {
    return [];
  }

  const indexedItems = items.map((item, i) => ({ item, originalIndex: i }));

  if (items.length <= minPerColumn) {
    return [indexedItems];
  }

  if (items.length <= minPerColumn * maxColumns) {
    const columns = [];
    let i = 0;

    while (i < items.length) {
      const take = Math.min(minPerColumn, items.length - i);
      columns.push(indexedItems.slice(i, i + take));
      i += take;
    }

    return columns;
  }

  const base = Math.floor(items.length / maxColumns);
  const remainder = items.length % maxColumns;
  const columns = [];
  let cursor = 0;

  for (let column = 0; column < maxColumns; column++) {
    const size = base + (column < remainder ? 1 : 0);
    columns.push(indexedItems.slice(cursor, cursor + size));
    cursor += size;
  }

  return columns;
}
